import { useStoreSsPlayer } from '~/stores/softswiss/player';

export default defineNuxtPlugin({
  hooks: {
    'app:created': () => {
      useStoreSsPlayer().loadEarlyAuthStatus();
    },
  },
});
